import React = require('react');
import { renderDirectoryDetails } from './DirectoryDetails';

export const MedicalSignpost = () => {

  return (
    <>
      <div style={{marginTop: '50px'}}>
        <img src={require('../../../../img/info-black.svg')} alt={'Admiral'}/> Whats next?
      </div>
      <div className={'medical-signpost-card'}>
        <>
          <div className={'title'}>
            You may be able to get cover through a specialist provider.
          </div>
          <div>
            The MoneyHelper travel insurance directory has been created for anyone who may have
            been refused Travel Insurance cover due
            to their medical conditions, to allow them to shop around for alternative providers.
          </div>
          {renderDirectoryDetails(true)}

          <div>
            <strong>Please note: </strong>If you’re insuring multiple travellers on separate policies, you may not be
            covered for
            claims related to the pre-existing medical conditions of someone not named on your policy.
          </div>
        </>
      </div>
    </>
  )
}
